import { Autocomplete, Box, SearchButton, TextField, filledInputClasses, styled } from "@tm/components"
import { inputBaseClasses, outlinedInputClasses } from "@mui/material"
import { VehicleSuggestions } from "./useVehicleSearchAutocomplete"

export const StyledAutoComplete = styled(Autocomplete<VehicleSuggestions, false, true>, {
    name: "StyledAutoComplete",
    overridesResolver(_, styles) {
        return styles.root
    },
    slot: "root",
})((_) => {
    return {
        [`.${outlinedInputClasses.root}`]: {
            padding: 0,
        },
        [`.${filledInputClasses.root} .${filledInputClasses.input}`]: {
            padding: 8,
        },
        [`.${inputBaseClasses.formControl}`]: {
            flexWrap: "nowrap",
        },
        [`& .${filledInputClasses.root}`]: {
            padding: 0,
            [`&.${inputBaseClasses.sizeSmall}`]: {
                paddingBottom: 0,
            },
        },
    }
})

export const StyledTextField = styled(TextField, {
    shouldForwardProp: (prop: string) => !["alwaysColoredBorder", "cutEdge", "size"].includes(prop),
})<{
    alwaysColoredBorder?: boolean
    cutEdge?: boolean
    hideOutline?: boolean
    size?: "small" | "medium" | "large"
}>(({ theme, alwaysColoredBorder, hideOutline, size }) => {
    const borderColor = theme.overwrites?.components?.textfield?.border?.color || (alwaysColoredBorder ? theme.palette.highlight.main : undefined)
    // const cutEdge = theme.overwrites?.components?.textfield?.cutEdge
    return {
        [`.${filledInputClasses.root}`]: {
            backgroundColor: theme.overwrites?.components?.textfield?.backgroundColor,
            ...(!hideOutline && borderColor && { border: `1px solid ${borderColor}` }),
            borderRadius: theme.radius?.default || "3px",
            input: {
                fontSize: theme.overwrites?.components?.textfield?.fontSize?.[size || "extralarge"] || "18px",
                lineHeight: theme.overwrites?.components?.textfield?.fontSize?.[size || "extralarge"] || "18px",
            },
        },
    }
})

export const InlineSearchButton = styled(
    SearchButton,
    {}
)(({ theme }) => {
    return {
        "&.MuiButton-sizeMedium": {
            borderRadius: `${theme.radius?.default || "2px"} !important`,
            padding: "7.5px",
        },
    }
})

export const GroupHeader = styled(Box, {
    name: "SuggestionsPaper",
    slot: "groupHeader",
    overridesResolver: (_, styles) => styles.groupHeader,
})(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "6px 10px",
    textTransform: "uppercase",
    backgroundColor: theme.palette.background.paper,
    zIndex: 1,
}))
